import { useMemo } from 'react';
import { LTSSService } from '../types/ltss';
import { useLocations } from '../contexts/LocationContext';
import { usePlanFeatures } from './usePlanFeatures';

export function useLocationFilter(services: LTSSService[]): LTSSService[] {
  const { activeLocation, allLocationsMode, getLocationByProvider } = useLocations();
  const { isEnterprise } = usePlanFeatures();

  return useMemo(() => {
    // If not enterprise or in all locations mode, return all services
    if (!isEnterprise || allLocationsMode || !activeLocation) {
      return services;
    }

    // Filter services by the active location's provider numbers
    return services.filter(service => {
      const serviceLocation = getLocationByProvider(service.providerNumber);
      return serviceLocation?.id === activeLocation.id;
    });
  }, [services, activeLocation, allLocationsMode, isEnterprise, getLocationByProvider]);
}
